import React from 'react';
import { styled } from '@linaria/react';

import { Link } from '../../ui';

const RecaptchaHint = styled.div`
  color: var(--bb-recaptcha-color);
  font-size: var(--bb-recaptcha-font-size);
  line-height: var(--bb-recaptcha-line-height);
  text-align: center;
  margin-top: 8px;

  & a {
    color: var(--bb-recaptcha-link-color);
  }
`;

const Recaptcha: React.FC = () => {
  return (
    <RecaptchaHint>
      This site is protected by reCAPTCHA and the Google{' '}
      <Link
        href="https://policies.google.com/privacy"
        rel="noreferrer nofollow"
      >
        Privacy Policy
      </Link>{' '}
      and{' '}
      <Link
        href="https://policies.google.com/terms"
        rel="noreferrer nofollow"
      >
        Terms of Service
      </Link>{' '}
      apply.
    </RecaptchaHint>
  );
};

export default React.memo(Recaptcha);
